// extracted by mini-css-extract-plugin
export default {"h1":"create_h1__gdLv9","container1":"create_container1__s2gmk"};